import React from 'react';
import PropTypes from 'prop-types';
import { LoadingDotContainer } from './styles';
import LoadingGif from '../../assets/loading.gif';

// const LoadingDot = (props) => {
//   // console.info('LoadingDot props ', props);
//   return props.show ? <LoadingDotContainer show={props.show} src={LoadingGif} alt="loading" /> : null;
// };

const LoadingDot = props => (props.show ? <LoadingDotContainer show={props.show} src={LoadingGif} alt="loading" /> : null);

LoadingDot.propTypes = {
  show: PropTypes.bool,
};

export default LoadingDot;
